import React from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Dialog } from '@material-ui/core'
import { useBoolState, useLazyUnEffect } from '../../../../hooks/commonHooks'
import { ColumnSelector } from '../../../features/columnSelector'
import { ExportProductsButton } from '../../../../components/ExportProductsButton'
import { Pagination } from './pagination'
import { Button } from '../../../shared/ui/button'
import { ProductsTableProps } from '../productsTable'
import { IServerTableData } from '../../../../types/tableTypes'
import { ExternalProductModel } from '../../../../server/mpsklad_core/Models/ExternalProductModel'
import { ProductsTableSearch } from '../../../features/productsTableSearch'
import { AccountModelBase } from '../../../../server/mpsklad_core/Models/AccountModelBase'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'

import filter from '../../../../assets/filter.svg'
import { ReactComponent as ImportIcon } from '../../../../assets/import.svg'
import { CardActionButton } from './cardActionButton'
import { CardMoveButton } from './cardMoveButton'
import { GeneralProductsImport } from '../../generalProductsImport'
import {
  clearMarketplacePresenceFilters, isPresenceFilterTable, MarketplacePresenceFilter
} from '../../../features/marketplacePresenceFilter/marketplacePresenceFilter'
import { makeStyles } from '@material-ui/core/styles'

interface FilterBarProps<TProducts extends IServerTableData<TRow, TColumnId>,
  TRow extends ExternalProductModel,
  TColumnId extends string>
  extends Pick<ProductsTableProps<TProducts, TRow, TColumnId>, 'products'> {
  account: AccountModelBase
    }

export const FilterBar =
  observer(<TProducts extends IServerTableData<TRow, TColumnId>,
    TRow extends ExternalProductModel,
    TColumnId extends string>({account, products}: FilterBarProps<TProducts, TRow, TColumnId>) => {
    const classes = useStyles()

    const [isFilterOpen, setFilterOpen, setFilterClosed] = useBoolState()
    const [isImportModalOpen, setImportModalOpen, setImportModalClose] = useBoolState()

    useLazyUnEffect(() => products.setGlobalFilter(null))

    if (!isPresenceFilterTable(products)) {
      throw new Error('Products table does not support marketplace presence filters')
    }

    const presenceProducts = products

    const toggleFilter = () => {
      if (isFilterOpen) {
        clearMarketplacePresenceFilters(account.integrationType, presenceProducts)
        setFilterClosed()
        return
      }

      setFilterOpen()
    }

    const onReloadTableCb = () => {
      products.load()
    }

    return <>
      <Box display="flex" alignItems="center">

        <ProductsTableSearch<TProducts, TRow, TColumnId> products={products}/>

        <Button icon={filter} onClick={toggleFilter} isActive={isFilterOpen} width={60}/>


        <ColumnSelector account={account}/>

        {
          products.selectedRowCount > 0 &&
          <>
            <button
              disabled
              type="button"
              className="button_counter"
            >
              Выбрано: {products.selectedRowCount}
            </button>
          </>
        }

        <Button icon={<ImportIcon className={'white_svg'}/>} onClick={setImportModalOpen} isActive={isFilterOpen}
                width={168}>
          <span>Обновить</span>
        </Button>

        <ExportProductsButton
          text={'Экспорт каталога'}
          width={168}
          integrationType={account.integrationType}
          accountId={account.id}
        />

        <CardMoveButton
          isActive={products.selectedRowCount > 0}
        />

        {account.integrationType !== IntegrationType.MoySklad && (
          <CardActionButton isActive={isFilterOpen} target={products.selectedRowCount > 0 ? 'EDIT' : 'CREATE'}/>
        )}

        <Pagination<TProducts, TRow, TColumnId> products={products}/>
      </Box>

      {
        // NOTE: Don't add click away listener - filters will reset when they unmount
        isFilterOpen &&
        <MarketplacePresenceFilter account={account} products={presenceProducts}/>
      }

      <Dialog
        open={isImportModalOpen}
        onClose={setImportModalClose}

        PaperProps={{
          className: classes.modal
        }}
      >
        <GeneralProductsImport onClose={setImportModalClose} onSuccess={onReloadTableCb}/>
      </Dialog>
    </>
  })

const useStyles = makeStyles(
  () => ({
    modal: {
      width: '700px',
      height: '330px',
      maxWidth: 'none',
      boxSizing: 'border-box'
    }
  }))